import AxiosService from "./axiosServices";

const BASE_VIZ_URL = process.env.REACT_APP_R_APIBASE;

const ReportsService = {
  fetchReportsList: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}get_saved_reports_details`,
      payload
    ).then((res) => res.data);
  },

  getParametersList: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}reporting_parameter_listing`,
      payload
    ).then((res) => res.data);
  },

  fetchFilteredBatchListForReport: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}reporting_batch_preview`,
      payload
    ).then((res) => res.data);
  },

  generateReport: (payload) => {
    return AxiosService.Post(`${BASE_VIZ_URL}generate_report`, payload).then(
      (res) => res.data
    );
  },

  // fetchReportFile: (reqData) => {
  //   return AxiosService.Post(`${BASE_VIZ_URL}fetch_report`, {
  //     ...reqData,
  //   }).then((res) => res.data);
  // },

  fetchReportById: (payload) => {
    return AxiosService.Post(
      `${BASE_VIZ_URL}fetch_report_template`,
      payload
    ).then((res) => res.data);
  },
};

export default ReportsService;
